import React from 'react';

import { Title, Button, ButtonsGroup } from 'components/commons';
import ContactUsDialog from './contact-us-dialog';
import coneIcon from 'assets/svg/cone.svg';

type GenericErrorLayoutProps = {
    onOk?:() => void;
}

const GenericErrorLayout: React.FC<GenericErrorLayoutProps> = ({ onOk }) => (
    <div className="message-box-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={coneIcon} />

                    <Title>
                        ah não! parece que <br className="d-block d-md-none" />
                        alguma coisa deu <br className="d-block d-md-none" />
                        errado!
                    </Title>

                    <p className="text">
                        Por favor, tente novamente. <br className="d-block d-xs-none" />Se o problema persistir, <ContactUsDialog label="fala com a gente" />
                    </p>
                </div>

                {onOk && (
                    <ButtonsGroup className="mt-3" align="left">
                        <Button label="continuar" onClick={onOk} />
                    </ButtonsGroup>
                )}
            </div>
        </div>
    </div>
);

export default GenericErrorLayout;
